"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoWrapper = exports.ExternalVideoRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const ExternalVideoRoot = exports.ExternalVideoRoot = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, isStandaloneVideo } = param;
    return {
        marginTop: isStandaloneVideo ? theme.spacing(4) : 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 985
        },
        [theme.breakpoints.up('lg')]: isStandaloneVideo ? {} : {
            maxWidth: 'unset'
        },
        iframe: {
            aspectRatio: '16 / 9',
            width: '100%',
            maxWidth: 985
        }
    };
});
const VideoWrapper = exports.VideoWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: 'auto',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 985
        }
    };
});
